import { ConfigData } from "@lib/titan2-slingo/dist/api/model/data/ConfigData";
import { SlingoConstants } from "@lib/titan2-slingo/dist/api/model/enum/SlingoConstants";
import { ExtendedPayoutConfigData } from "./ExtendedPayoutConfigData";
/**
 * ExtendedConfigData.ts
 */
export class ExtendedConfigData extends ConfigData {
    solidifyPayoutConfig() {
        let payoutConfig = this.data.getDataObject(SlingoConstants.PROPERTY_PAYOUT_CONFIG);
        if (this.dataExists(payoutConfig)) {
            this.payoutConfig = new ExtendedPayoutConfigData(payoutConfig);
        }
    }
}
//# sourceMappingURL=ExtendedConfigData.js.map